// extracted by mini-css-extract-plugin
export var root = "container-module--root--e7d6c";
export var rootNarrow = "container-module--rootNarrow--1a4c6";
export var rootWide = "container-module--rootWide--b497c";